import { colors } from '@components/theme/styles/index';
import { styled } from '@mui/material';
import { rem } from 'polished';

export const StyledTabPanel = styled('div')({
  backgroundColor: colors.grayLight2,
  flexGrow: 1,
  paddingTop: rem(40),
  paddingBottom: rem(40),
});

export const StyledTabPanelBody = styled('div')({
  marginLeft: 'auto',
  maxWidth: rem(840),
  marginRight: 'auto',
  paddingRight: rem(20),
  paddingLeft: rem(20),
});
